import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
/**
 * Spacemesh API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2alpha1
 *
 * NOTE: This class is auto generated by OpenAPI-Generator
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var Configuration = /*#__PURE__*/_createClass(
/**
 * parameter for apiKey security
 * @param name security name
 * @memberof Configuration
 */

/**
 * parameter for basic security
 *
 * @type {string}
 * @memberof Configuration
 */

/**
 * parameter for basic security
 *
 * @type {string}
 * @memberof Configuration
 */

/**
 * parameter for oauth2 security
 * @param name security name
 * @param scopes oauth2 scope
 * @memberof Configuration
 */

/**
 * override base path
 *
 * @type {string}
 * @memberof Configuration
 */

function Configuration() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  _classCallCheck(this, Configuration);
  if (param.apiKey) {
    this.apiKey = param.apiKey;
  }
  if (param.username) {
    this.username = param.username;
  }
  if (param.password) {
    this.password = param.password;
  }
  if (param.accessToken) {
    this.accessToken = param.accessToken;
  }
  if (param.basePath) {
    this.basePath = param.basePath;
  }
});